<ng-container *ngIf="isSampling(catalogueItem)">
  <app-sampling-supply-detail id="sampling-supply-detail"
    [inputCatalogueItem]="catalogueItem"
    [container]="container"
    (closeDialog)="toLastVisitedPage()"
  ></app-sampling-supply-detail>
</ng-container>
